import React from "react";

const ExploreCollegeBar: React.FC = () => {
  return (
    <div className="flex justify-center w-full" style={{ height: '61px', margin: '0 auto' }}>
      <div 
        className="w-full bg-[#173CBA] text-white flex items-center justify-center h-[50px]"
        style={{ 
          width: '1197px',
          margin: '0 auto',
        }}
      >
        <div className="text-center">
          <span 
            className="text-[#00CC99] font-bold mr-2"
            style={{ 
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: '32px',
              lineHeight: '50px',
              letterSpacing: '0%',
              verticalAlign: 'middle'
            }}
          >
            CURIOUS
          </span>
          <span 
            className="text-white"
            style={{ 
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: '32px',
              lineHeight: '50px',
              letterSpacing: '0%',
              verticalAlign: 'middle'
            }}
          >
            About which college you can get with this rank? Explore now!
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExploreCollegeBar;
